<template>
  <div class="mb-4 mx-4">
    <div class="main-title mt-4 mb-3 text-xs-center">Monthly dashboard</div>
    <v-layout wrap>
      <v-flex xs12 class="pa-3">
        <v-card
          style="border-radius: 20px"
          class="card__btn"
          @click="
            $router.push({
              path: '/weserve_admin_login/-/reportdashboard/main/reward-report',
            })
          "
        >
          <div class="pa-3 text-xs-center body__btn--icon">
            <span style="font-weight:500;font-size:28px">Reward</span>
          </div>
          <v-card-text class="v_card__text">
            <div class="body__card--nodata" v-if="isLoadingReward == true">
              <v-progress-circular
                :width="20"
                :size="150"
                color="primary"
                indeterminate
              ></v-progress-circular>
            </div>
            <div
              class="body__card--nodata"
              v-else-if="rewardReportChart.xaxis.categories.length == 0"
            >
              <div>No data available</div>
            </div>
            <ChartLine :options="rewardReportChart" v-else />

            <div class="body__btn">
              <div class="body__btn--icon">
                <span style="color: #2196f3">Click to view table</span>
                <v-icon class="icon--back" color="info">chevron_right</v-icon>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 class="pa-3">
        <v-card
          style="border-radius: 20px"
          class="card__btn"
          @click="
            $router.push({
              path:
                '/weserve_admin_login/-/reportdashboard/main/packages-report',
            })
          "
        >
          <div class="pa-3 text-xs-center">
            <span style="font-weight:500;font-size:28px">Packages</span>
          </div>
          <v-card-text class="v_card__text">
            <!-- <div class="body__card--nodata" v-if="isLoadingPackages == true">
              <v-progress-circular
                :width="20"
                :size="150"
                color="primary"
                indeterminate
              ></v-progress-circular>
            </div>
            <div
              class="body__card--nodata"
              v-else-if="PackagesReportChart.xaxis.categories.length == 0"
            >
              NO DATA
            </div>
            <ChartLine :options="PackagesReportChart" v-else /> -->
            <div class="body__btn">
              <div class="body__btn--icon">
                <span style="color: #2196f3">Click to view table</span>
                <v-icon class="icon--back" color="info">chevron_right</v-icon>
              </div>
            </div>
          </v-card-text></v-card
        ></v-flex
      >
    </v-layout>
  </div>
</template>

<script>
import ChartLine from "@/components/back-office/Report/MainDashboard/ChartLine.vue";
export default {
  data() {
    return {
      isLoadingReward: false,
      isLoadingPackages: false,
      rewardReportChart: {
        chart: {
          type: "line",
        },
        series: [
          {
            name: "Total paid price",
            data: [],
          },
        ],
        plotOptions: {
          bar: {
            borderRadius: 4,
            horizontal: true,
          },
        },
        colors: ["#fddf00"],
        xaxis: {
          categories: [],
        },
      },
      PackagesReportChart: {
        chart: {
          type: "bar",
        },
        series: [
          {
            name: "Total paid price",
            data: [],
          },
        ],
        plotOptions: {
          bar: {
            borderRadius: 4,
            horizontal: true,
          },
        },
        dataLabels: {
          enabled: true,
        },
        xaxis: {
          categories: [],
        },
      },
    };
  },
  components: {
    ChartLine,
  },
  methods: {
    async fetchTodayReward() {
      this.isLoadingReward = true;
      let config_path = {
        datetime_start: this.moment()
          .startOf("month")
          .format("YYYY-MM-DD"),
        datetime_end: this.moment()
          .endOf("month")
          .format("YYYY-MM-DD"),
        province_id: 0,
      };
      let response = await this.$store.dispatch(
        "report/fetchReportList",
        config_path
      );
      if (this.rewardReportChart.series.length > 0) {
        this.rewardReportChart.series[0].data =
          response.data.map((val) => val.total_paid_price) || [];
      }
      this.rewardReportChart.xaxis.categories = this.rewardReportChart.xaxis.categories =
        response.data.map((val) => val.campaign_name) || [];
      this.isLoadingReward = false;
      return;
    },
    async fetchTodayPackages() {
      // this.isLoadingPackages = true;
      // let config_path = {
      //   datetime_start: this.moment().format("YYYY-MM-DD"),
      //   datetime_end: this.moment().format("YYYY-MM-DD"),
      //   province_id: 0,
      // };
      // let response = await this.$store.dispatch(
      //   "report/fetchReportList",
      //   config_path
      // );
      // if (this.PackagesReportChart.series.length > 0) {
      //   this.PackagesReportChart.series[0].data =
      //     response.data.map((val) => val.total_paid_price) || [];
      // }
      // this.PackagesReportChart.xaxis.categories =
      //   this.PackagesReportChart.xaxis.categories =
      //     response.data.map((val) => val.campaign_name) || [];
      // this.isLoadingPackages = false;
      return;
    },
  },
  async created() {
    await this.fetchTodayReward();
    await this.fetchTodayPackages();
  },
};
</script>

<style lang="css" scoped>
.main-title {
  font-size: 36px;
  font-weight: bold;
}

.body__btn {
  border-radius: 10px;
  font-size: 16px;
  font-weight: bold;
  /* color: black !important; */
  /* background-color: var(--primaryColor); */
}

@keyframes shake {
  0% {
    transform: translateX(0px);
    opacity: 1;
  }

  100% {
    transform: translateX(10px);
    opacity: 0;
  }
}
.body__btn--icon {
  width: 100%;
  text-align: right;
}
.body__btn--icon:hover > .icon--back {
  animation: shake 500ms infinite;
}

.body__card--nodata {
  height: 315px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  /* font-weight: bold; */
  color: grey;
}

.card__btn {
  cursor: pointer;
}

.card__btn:hover {
  background-color:rgba(218,239,255,.1);
}

.card__btn:hover > .v_card__text > .body__btn > .body__btn--icon > .icon--back {
  animation: shake 500ms infinite;
}
</style>
